import BaseToolbar from "./base-toolbar";
import { withProps, defaultProps, compose, setDisplayName } from 'react-recompose';
import { textAlignments } from "../../../enums";
import { removeProps } from "../../core/hoc";
var EditorToolbar = compose(setDisplayName('EditorToolbar'), removeProps(['onClose']), defaultProps({
  hasBorder: true,
  textAlign: textAlignments.RIGHT
}), withProps(function (props) {
  return {
    isIconDivided: (props.tabMenu || props.textAlign === textAlignments.LEFT) && !!props.icon,
    areActionsDivided: props.textAlign === textAlignments.RIGHT,
    toolbarType: 'editor'
  };
}))(BaseToolbar);
export default EditorToolbar;
//# sourceMappingURL=editor-toolbar.js.map